import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplierBuyerCardComponent } from './supplier-buyer-card/supplier-buyer-card.component';
import { SupplierBuyerCardModule } from './supplier-buyer-card/supplier-buyer-card.module';
import { SupplierBuyerSaleDetailsComponent } from './supplier-buyer-sale-details.component';
import { BuyerSupplierService } from '../../services/buyer-supplier.service';



@NgModule({
  declarations: [SupplierBuyerSaleDetailsComponent
  ],
  imports: [
    CommonModule,
    SupplierBuyerCardModule,
  ],
  exports: [SupplierBuyerSaleDetailsComponent],
  providers: [BuyerSupplierService]
})
export class SupplierBuyerSaleDetailsModule { }
